import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9 1.5H5.25C4.00736 1.5 3 2.50736 3 3.75V14.25C3 15.4926 4.00736 16.5 5.25 16.5H12.75C13.9926 16.5 15 15.4926 15 14.25V7.5H11.25C10.0074 7.5 9 6.49264 9 5.25V1.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.5607 6L10.5 1.93934V5.25C10.5 5.66421 10.8358 6 11.25 6H14.5607Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }